import React, { useState, useEffect, useMemo, useCallback } from "react";
import Axios from "axios";
import Select from "react-select";
import secureLocalStorage from "react-secure-storage";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import moment from "moment-timezone";
import MUIDataTable from "mui-datatables";
import { Link } from "react-router-dom";
import "../../routes/track_status.css";
import Status_change from "../../routes/status_change";
import "../../routes/popup.css";
import { Button } from "@mui/material";
import * as XLSX from "xlsx";

export default function Filter_component() {
  // 1. ALL STATES DEFINED FIRST (Prevents "Cannot access before initialization" errors)
  const getDefaultFromDate = () =>
    moment().subtract(3, "months").format("YYYY-MM-DD");
  const getDefaultToDate = () => moment().format("YYYY-MM-DD");

  const [details, setDetails] = useState([]);
  const [order_id, setorderids] = useState([]);
  const [oid, setOid] = useState("");
  const [selectedOrdermill, setSelectedOrdermill] = useState("");
  const [selectedArticle, setSelectedArticle] = useState("");
  const [articles, setArticles] = useState([]);
  const [shades, setShades] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [selectedShade, setSelectedShade] = useState("");
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [selectedPo, setSelectedPo] = useState(null);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedvalue, setselectedvalue] = useState("10");
  const [offset, setOffset] = useState(0);
  const [selectedOrderstatuscodes, setSelectedOrderstatuscodes] = useState([]);
  const [selectedPos, setSelectedPos] = useState([]);
  const [showUpStatusPopup, setShowUpStatusPopup] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [fromDate, setFromDate] = useState(getDefaultFromDate);
  const [toDate, setToDate] = useState(getDefaultToDate);

  // Storage Variables
  const role = secureLocalStorage.getItem("role");
  const uname = secureLocalStorage.getItem("activeUser");
  const current_user = "SIRIUS";
  const mill = secureLocalStorage.getItem("mill");
  const token = secureLocalStorage.getItem("token");

  // 2. STATIC MEMOS
  const statuses = useMemo(() => {
    if (role === "Dyeing") return ["Dyeing", "Packing"];
    if (role === "Winding") return ["Winding", "Packing"];
    if (uname === current_user) {
      return [
        "Order Created",
        "Order Released",
        "Packing",
        "Shortclosed",
        "Closed Automatically",
        "Order Reopened",
      ];
    }
    return [
      "Order Created",
      "Order Released",
      "Dyeing",
      "Winding",
      "Packing",
      "Shortclosed",
      "Closed Automatically",
      "Order Reopened",
    ];
  }, [role, uname]);

  // 3. CALLBACK HANDLERS
  const format_date = useCallback((utcDate) => {
    if (!utcDate) return "";
    return moment.utc(utcDate).tz("Asia/Kolkata").format("YYYY-MM-DD");
  }, []);

  const handleEditClick = useCallback((orderId, po) => {
    setSelectedOrderId(orderId);
    setSelectedPo(po);
    setShowUpStatusPopup(true);
  }, []);

  const handlePopupClose = () => {
    setSelectedOrderId(null);
    setSelectedPo(null);
    setShowUpStatusPopup(false);
  };

  // 4. API RETRIEVAL ENGINE
  const combo_filter = useCallback(
    async (forcedPage, forcedPageSize) => {
      const activePage = forcedPage !== undefined ? forcedPage : page;
      const activePageSize =
        forcedPageSize !== undefined ? forcedPageSize : pageSize;
      const effectiveFromDate = fromDate || getDefaultFromDate();
      const effectiveToDate = toDate || getDefaultToDate();

      console.log("fromDate", effectiveFromDate);
      console.log("toDate", effectiveToDate);
      try {
        let dataPayload;
        if (mill === "COATS") {
          const response = await Axios.post(
            `${process.env.REACT_APP_API_URL}/order/combo_filter`,
            {
              id: oid,
              mill: selectedOrdermill,
              statuscode: selectedOrderstatuscodes,
              date1: effectiveFromDate,
              date2: effectiveToDate,
              article: selectedArticle,
              shade: selectedShade,
              po: selectedPos,
              po_textbox: inputValue,
              page: activePage,
              pageSize: activePageSize,
              uname: uname,
            },
            {
              headers: {
                "x-access-token": token,
                "Content-Type": "application/json",
              },
            },
          );
          dataPayload = response.data;
        } else {
          const response = await Axios.post(
            `${process.env.REACT_APP_API_URL}/order/combo_filter_vendor`,
            {
              id: oid,
              mill_search: selectedOrdermill,
              statuscode: selectedOrderstatuscodes,
              date1: effectiveFromDate,
              date2: effectiveToDate,
              mill: mill,
              article: selectedArticle,
              shade: selectedShade,
              role: role,
              page: activePage,
              pageSize: activePageSize,
            },
            {
              headers: {
                "x-access-token": token,
                "Content-Type": "application/json",
              },
            },
          );
          dataPayload = response.data;
        }

        if (dataPayload) {
          const count = dataPayload.totalCount || 0;
          const results = dataPayload.result || [];
          setTotalRecords(count);
          setTotalPages(Math.ceil(count / activePageSize));

          if (activePage === 1) {
            setDetails(results);
          } else {
            setDetails((prev) => [...prev, ...results]);
          }
        }
      } catch (err) {
        console.error("Failed fetching collection details:", err);
      }
    },
    [
      oid,
      selectedOrdermill,
      selectedOrderstatuscodes,
      fromDate,
      toDate,
      selectedArticle,
      selectedShade,
      selectedPos,
      inputValue,
      page,
      pageSize,
      mill,
      role,
      uname,
      token,
    ]
  );

  const handleStatusUpdate = useCallback(
    (orderId, newStatus) => {
      setDetails((prevDetails) => {
        let updated;
        if (
          selectedOrderstatuscodes.includes(newStatus) ||
          selectedOrderstatuscodes.length === 0
        ) {
          updated = prevDetails.map((order) =>
            order.sc_order_no === orderId
              ? { ...order, statuscode: newStatus }
              : order
          );
        } else {
          updated = prevDetails.filter(
            (order) => order.sc_order_no !== orderId
          );
        }
        setTotalRecords(updated.length);
        return updated;
      });
    },
    [selectedOrderstatuscodes]
  );

  // 5. EFFECT LIFE-CYCLES
  useEffect(() => {
    combo_filter();
  }, [page, pageSize, offset]);

  useEffect(() => {
    Axios.post(
      `${process.env.REACT_APP_API_URL}/label/article_disp`,
      {},
      {
        headers: {
          "x-access-token": token,
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => setArticles(res.data || []))
      .catch(console.error);

    Axios.post(
      `${process.env.REACT_APP_API_URL}/label/shade_disp`,
      {},
      {
        headers: {
          "x-access-token": token,
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => setShades(res.data || []))
      .catch(console.error);
  }, [token]);

  // 6. COMPLEX DATA LOOKUPS MEMOIZED (Safe because all parameters are loaded now)
  const columns = useMemo(
    () => [
      {
        name: "Edit",
        options: {
          filter: false,
          label: "Edit",
          customBodyRender: (value, tableMeta) => {
            const index = tableMeta.rowIndex;
            const targetDataSource =
              filteredData.length === 0 ? details : filteredData;
            if (!targetDataSource[index]) return null;

            const id = targetDataSource[index].sc_order_no;
            const po_num = targetDataSource[index].po_number;
            return (
              <Link
                to="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleEditClick(id, po_num);
                }}
              >
                <img
                  src="https://cdn3.iconfinder.com/data/icons/streamline-icon-set-free-pack/48/Streamline-22-512.png"
                  width="15"
                  height="15"
                  alt="Edit"
                />
              </Link>
            );
          },
        },
      },
      { name: "po_number", label: "PO Number" },
      {
        name: "material",
        label: "Art",
        options: {
          customBodyRender: (value) => (value ? value.substr(0, 4) : ""),
        },
      },
      { name: "material", label: "Material" },
      {
        name: "sap_order_date",
        label: "SAP Order Date",
        options: { customBodyRender: (value) => format_date(value) },
      },
      { name: "ord_qty", label: "Order Quantity" },
      { name: "pendingqty", label: "Pending Quantity" },
      {
        name: "due_date",
        label: "Due Date",
        options: { customBodyRender: (value) => format_date(value) },
      },
      { name: "statuscode", label: "Status" },
      { name: "uname", label: "User Name" },
      { name: "rec_plant", label: "Rec_plant" },
    ],
    [details, filteredData, handleEditClick, format_date]
  );

  const options2 = useMemo(
    () => statuses.map((item) => ({ label: item, value: item })),
    [statuses]
  );
  const filteredOptions3 = useMemo(
    () =>
      articles.map((item) => ({
        label: item.material_code,
        value: item.material_code,
      })),
    [articles]
  );
  const filteredOptions4 = useMemo(() => {
    const unique = [];
    const seen = new Set();
    for (let i = 0; i < shades.length; i++) {
      const val = shades[i].shade;
      if (!seen.has(val)) {
        seen.add(val);
        unique.push({ label: val, value: val });
      }
    }
    return unique;
  }, [shades]);

  const memoizedTableOptions = useMemo(
    () => ({
      download: false,
      print: false,
      selectableRows: "none",
      sort: false,
      filter: false,
      viewColumns: false,
      search: false,
      page: page - 1,
      rowsPerPage: pageSize,
      rowsPerPageOptions: [10, 20, 100, 300, 500],
      count: totalRecords,
      onChangePage: (newPage) => {
        setOffset(newPage * pageSize);
        setPage(newPage + 1);
      },
      onChangeRowsPerPage: (newPageSize) => {
        setPageSize(newPageSize);
        setPage(1);
        setOffset(0);
      },
      downloadOptions: {
        filename: "OrderDetails.csv",
        filterOptions: {
          useDisplayedColumnsOnly: true,
          useDisplayedRowsOnly: true,
        },
      },
    }),
    [page, pageSize, totalRecords]
  );

  // Form Interactions
  const handleFilterClick = () => setShowFilters((prev) => !prev);
  const buttonStyle = showFilters ? "line-button" : "filter-button";
  const clear_values = () => {
    setOid("");
    setSelectedOrderstatuscodes([]);
    setSelectedOrdermill("");
    setSelectedArticle("");
    setSelectedShade("");
    setFromDate(getDefaultFromDate());
    setToDate(getDefaultToDate());
    setSelectedPos([]);
    setInputValue("");
    setPage(1);
    setPageSize(10);
    setDetails([]);
    combo_filter(1, 10);
  };

  const getdetails2 = (opts) =>
    setSelectedOrderstatuscodes(opts ? opts.map((o) => o.value) : []);
  const getdetails3 = (opt) => setSelectedArticle(opt ? opt.value : "");
  const getdetails4 = (opt) => setSelectedShade(opt ? opt.value : "");
  const setdate1 = (e) => setFromDate(e.target.value || getDefaultFromDate());
  const setdate2 = (e) => setToDate(e.target.value || getDefaultToDate());
  const handleInputChange = (e) => setInputValue(e.target.value);

  const placeholderOption4 = { label: "Search Article", value: null };
  const placeholderOption5 = { label: "Search Shade", value: null };

  const downloadData = async () => {
    let rawData = [];
    try {
      let res;
      const effectiveFromDate = fromDate || getDefaultFromDate();
      const effectiveToDate = toDate || getDefaultToDate();

        res = await Axios.post(
          `${process.env.REACT_APP_API_URL}/order/status_data_download`,
          {
            id: oid,
            mill: mill,
            statuscode: selectedOrderstatuscodes,
            date1: effectiveFromDate,
            date2: effectiveToDate,
            article: selectedArticle,
            shade: selectedShade,
            po: selectedPos,
            po_textbox: inputValue,
            page,
            pageSize,
            role,
          },
          {
            headers: {
              "x-access-token": token,
              "Content-Type": "application/json",
            },
          },
        );
      rawData = res.data || [];
      if (rawData.length !== 0) {
        const ws = XLSX.utils.json_to_sheet(rawData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "data");
        const buffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = "Update Status Data.xlsx";
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(a.href);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      <h3 style={{ marginLeft: "55px" }} data-cy="order_label">
        Update Status
      </h3>
      <br />
      <button
        onClick={handleFilterClick}
        style={{ marginLeft: "50px" }}
        className={buttonStyle}
      >
        Filter
      </button>
      {showFilters && (
        <div>
          <div
            style={{
              width: "80%",
              display: "flex",
              justifyContent: "space-evenly",
              marginLeft: "50px",
            }}
          >
            <Select
              className="select_ord"
              value={
                selectedArticle
                  ? { label: selectedArticle, value: selectedArticle }
                  : null
              }
              options={[placeholderOption4, ...filteredOptions3]}
              onChange={getdetails3}
              placeholder="Search Article"
            />
            <Select
              className="select_ord"
              value={
                selectedShade
                  ? { label: selectedShade, value: selectedShade }
                  : null
              }
              options={[placeholderOption5, ...filteredOptions4]}
              onChange={getdetails4}
              placeholder="Search Shade"
            />
            <Select
              className="select_ord"
              isMulti
              value={selectedOrderstatuscodes.map((opt) => ({
                label: opt,
                value: opt,
              }))}
              options={options2}
              onChange={getdetails2}
              placeholder="Search Statuscode"
            />
          </div>

          <div
            style={{
              width: "50%",
              display: "flex",
              justifyContent: "space-evenly",
              marginLeft: "50px",
            }}
          >
            {role === "Admin" && (
              <div>
                <br />
                <TextareaAutosize
                  minRows={3}
                  placeholder="Enter PO's (Eg:PO1,PO2...)"
                  value={inputValue}
                  onChange={handleInputChange}
                  style={{ width: "400px", height: "100px" }}
                />
              </div>
            )}

            <div>
              <label id="label">From</label>
              <input
                className="date_filter"
                type="date"
                id="from_date"
                value={fromDate || ""}
                max={toDate ? toDate : new Date().toISOString().split("T")[0]}
                onChange={setdate1}
              />
            </div>
            <div>
              <label id="label">To</label>
              <input
                className="date_filter"
                type="date"
                id="to_date"
                value={toDate || ""}
                min={fromDate || ""}
                max={new Date().toISOString().split("T")[0]}
                onChange={setdate2}
              />
            </div>
          </div>

          <button
            style={{ float: "right", marginRight: "100px" }}
            className="btn btn-primary"
            id="filter_button"
            onClick={() => {
              setPage(1);
              setPageSize(10);
              setDetails([]);
              combo_filter(1, 10);
            }}
          >
            Apply
          </button>

          <button
            style={{ float: "right", marginRight: "20px" }}
            className="btn btn-primary"
            id="filter_button"
            onClick={clear_values}
          >
            Clear
          </button>
          <br />
          <br />
          <button className="lineb" style={{ marginLeft: "50px" }} />
        </div>
      )}
      <br /> <br />
      <div style={{ width: "95%", display: "flex", justifyContent: "right" }}>
        <Button variant="contained" color="primary" onClick={downloadData}>
          Download
        </Button>
      </div>
      <br />
      <div
        style={{
          marginLeft: "55px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          maxWidth: "93%",
        }}
      >
        <div style={{ width: "100%" }}>
          <MUIDataTable
            data={details}
            columns={columns}
            options={memoizedTableOptions}
            className="custom-table"
          />
        </div>
      </div>
      {showUpStatusPopup && (
        <div className="popup">
          <Status_change
            po={selectedPo}
            orderId={selectedOrderId}
            onClose={handlePopupClose}
            onStatusUpdate={handleStatusUpdate}
          />
        </div>
      )}
    </div>
  );
}
